module.exports = __webpack_public_path__ + "img/hero-shape-14.017909d3.png";